import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(() => ({
  formControl: {
    margin: 0,
    width: '100%'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  chip: {
    margin: 2
  }
}))
